import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import { withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import Tooltip from "@mui/material/Tooltip";
import Button from "components/CustomButtons/Button.js";
import AddIcon from "@mui/icons-material/Add";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

export default function AddMeters({ buttonTitle, dialogTitle, content}) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Tooltip title={buttonTitle}>
        <Button
          onClick={handleClickOpen}
          color={"success"}
          className={classes.actionButton}
        >
          <AddIcon fontSize="large" />
        </Button>
      </Tooltip>
      <Dialog
        onClose={handleClose}
        aria-labelledby="addMarket-dialog-title"
        //fullWidth={true}
        maxWidth="sm"
        open={open}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleClose}>
        {dialogTitle}
        </CustomDialogTitle>
        <DialogContent dividers>
        {content}
        </DialogContent>
        <DialogActions />
      </Dialog>
    </div>
  );
}
